import { render } from "./WegowSelect.vue?vue&type=template&id=39907360"
import script from "./WegowSelect.vue?vue&type=script&lang=js"
export * from "./WegowSelect.vue?vue&type=script&lang=js"

import "./WegowSelect.vue?vue&type=style&index=0&id=39907360&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__